module.exports = __webpack_public_path__ + "static/media/keith_chia_cv.8c6d8ae3.pdf";